import React from 'react'

const IcSO = ({ className, size = 20 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.66683 1.66699H3.00016C2.55814 1.66699 2.13421 1.84259 1.82165 2.15515C1.50909 2.46771 1.3335 2.89163 1.3335 3.33366V16.667C1.3335 17.109 1.50909 17.5329 1.82165 17.8455C2.13421 18.1581 2.55814 18.3337 3.00016 18.3337H13.0002C13.4422 18.3337 13.8661 18.1581 14.1787 17.8455C14.4912 17.5329 14.6668 17.109 14.6668 16.667V6.66699M9.66683 1.66699L14.6668 6.66699M9.66683 1.66699V6.66699H14.6668M11.3335 10.8337H4.66683M11.3335 14.167H4.66683M6.3335 7.50033H4.66683" stroke="#667085" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

)

export default IcSO
